<template lang="pug">
    div
        Modal(
            :title="slb.hostname"
            v-model="showResult"
            draggable
            @on-ok="clearTest"
            @on-cancel="clearTest"
            width="800"
        )
            p Testing Url: {{ testUrl }}
            p
                | Testing Probe Count: {{ completeNodesCount }} / {{ testNodes.length }}
            Progress(:percent="testPercent" status="active" hide-info)
            Table(
                ref="optimizeTable",
                :columns="talbleColumns",
                :data="testResult"
            )
        Button(@click="optimize" size="small" icon="ios-speedometer") optimize

</template>
<script>
import { lineOptimize } from "@/api/3rd/17ce.js";
import numeral from "numeral";
import { _dateFormat } from "@/libs/dateformat.js";

const nodesInfo = require("@/data/17ceNodes.json");

export default {
    name: "LineOptimize",
    props: ["slb"],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            // nodesInfo: nodesInfo,
            showResult: false,
            talbleColumns: [
                {
                    title: "Region",
                    width: "100px",
                    // key: "region",
                    render: (h, params) => {
                        // 補上地區
                        let regionObj = this.$store.state.backendData.thirdParty.lineOptimize.regionInfo.find(
                            region =>
                                region.provinces.find(
                                    province =>
                                        province.provinceId ==
                                        params.row.province
                                )
                        );
                        let regionName = regionObj ? regionObj.regionName : "";
                        var latency = params.row.latency;
                        return h(
                            "div",
                            {
                                style: {
                                    color:
                                        latency < 0
                                            ? "red"
                                            : latency >= 0 && latency < 51
                                            ? "green"
                                            : "orange"
                                }
                            },
                            regionName
                        );
                    }
                },
                {
                    title: "Province",
                    key: "province",
                    render: (h, params) => {
                        let nodeInfo = nodesInfo.find(
                            e => e.pid == params.row.province
                        );
                        let province = nodeInfo
                            ? nodeInfo.province
                            : params.row.province;
                        var latency = params.row.latency;
                        return h(
                            "div",
                            {
                                style: {
                                    color:
                                        latency < 0
                                            ? "red"
                                            : latency >= 0 && latency < 51
                                            ? "green"
                                            : "orange"
                                }
                            },
                            province
                        );
                    }
                },
                {
                    title: "Telecom",
                    key: "telecom",
                    render: (h, params) => {
                        var latency = params.row.latency;
                        let ispsTable = {
                            1: "电信",
                            2: "联通",
                            7: "移动"
                        };
                        return h(
                            "div",
                            {
                                style: {
                                    color:
                                        latency < 0
                                            ? "red"
                                            : latency >= 0 && latency < 51
                                            ? "green"
                                            : "orange"
                                }
                            },
                            ispsTable[params.row.telecom]
                        );
                    }
                },
                {
                    title: "Latency",
                    key: "latency",
                    sortable: true,
                    sortMethod: (a, b, type) =>
                        this.sortTableMethod(a, b, type),
                    render: (h, params) => {
                        var latency = params.row.latency;
                        return h(
                            "div",
                            {
                                style: {
                                    // color: params.row.latency < 50 ? "green" : "orange"
                                    color:
                                        latency < 0
                                            ? "red"
                                            : latency >= 0 && latency < 51
                                            ? "green"
                                            : "orange"
                                }
                            },
                            latency > 0
                                ? latency + " ms"
                                : latency < 0
                                ? "failed"
                                : "running.."
                        );
                    }
                },
                {
                    title: "Speed",
                    key: "speed",
                    sortable: true,
                    width: "160px",
                    sortMethod: (a, b, type) =>
                        this.sortTableMethod(a, b, type),
                    render: (h, params) => {
                        var speed = params.row.speed;
                        return h(
                            "div",
                            {
                                style: {
                                    // color: params.row.speed > 10 ? "green" : "orange"
                                    color:
                                        speed < 0 || speed == null
                                            ? "red"
                                            : speed >= 1024000
                                            ? "green"
                                            : "orange"
                                }
                            },
                            speed > 0
                                ? numeral(speed).format("0.00b") + " /s"
                                : speed < 0
                                ? "failed"
                                : "running.."
                        );
                    }
                },
                {
                    title: "testDate",
                    key: "testdate",
                    sortable: true,
                    width: "250px",
                    render: (h, params) => {
                        let dateString =
                            params.row.testdate == null
                                ? "---"
                                : _dateFormat(
                                      params.row.testdate,
                                      "YYYY-MM-DD HH:mm:ss.SSS"
                                  );
                        return h("div", dateString);
                    }
                }
            ],
            testResult: [],
            testNodes: []
            // completeNodesCount: 0
        };
    },
    methods: {
        sortTableMethod(a, b, type) {
            return type == "asc" ? a - b : b - a;
        },
        optimize() {
            lineOptimize({
                testUrl: this.testUrl,
                sid: this.$store.state.socketInfo.socketId
            });

            // 測試數據效果
            // var self = this;
            // this.testNodesCount = 6;
            // let testPush = setInterval(function() {
            //   self.testResult.push({
            //     latency: (Math.random() * 100).toFixed(2),
            //     speed: (Math.random() * 10000).toFixed(2),
            //     province: 180,
            //     city: 201,
            //     telecom: 2,
            //     testfrom: "2.3.4.5",
            //     testdate: new Date().getTime()
            //   });
            //   self.testResult = self.testResult.sort((a, b) => {
            //     let l1 = parseFloat(a.latency);
            //     let l2 = parseFloat(b.latency);
            //     return l1 < l2 ? -1 : l1 > l2 ? 1 : 0;
            //   });
            //   self.completeNodesCount += 1;
            //   if (self.testPercent >= 100) clearInterval(testPush);
            // }, 1000);

            this.showResult = true;
        },
        clearTest() {
            this.testResult = [];
            this.testNodes = [];
            // this.completeNodesCount = 0;
        }
    },
    mounted() {},
    computed: {
        testUrl() {
            return this.slb.isDummySlb
                ? `http://${this.slb.serviceIP}:80`
                : `http://${this.slb.serviceIP}:5404/100k.bin`;
        },
        testPercent() {
            return (this.completeNodesCount / this.testNodes.length) * 100;
        },
        completeNodesCount() {
            return this.testResult.filter(
                result => result.speed !== null && result.latency !== null
            ).length;
        }
    },
    sockets: {
        updateLineTestResult: function(result) {
            if (result.testUrl == this.testUrl) {
                switch (result.type) {
                    case "TaskAccept":
                        // 將要測試的節點填上
                        this.testNodes = result.testNodes;
                        this.testResult = result.testNodes.map(e => ({
                            province: e.pro_id,
                            city: e.city_id,
                            telecom: e.isp,
                            testFrom: e.ip,
                            latency: null,
                            speed: null,
                            testDate: null
                        }));
                        break;
                    case "NewData":
                        // this.testResult.push(result.data);

                        // 收到資料 補上測試數據
                        let nodeIndex = this.testResult.findIndex(
                            e => e.testFrom == result.data.testFrom
                        );
                        this.testResult[nodeIndex] = result.data;

                        this.testResult = this.testResult.sort((a, b) => {
                            let l1 = parseFloat(a.latency);
                            let l2 = parseFloat(b.latency);
                            return l1 < l2 ? -1 : l1 > l2 ? 1 : 0;
                        });
                        // this.completeNodesCount++;
                        break;
                    case "TaskEnd":
                        this.testResult = this.testResult.map(e => {
                            e.speed = e.speed == null ? -1 : e.speed;
                            e.latency = e.latency == null ? -1 : e.latency;
                            return e;
                        });
                        this.$Message.success("測試完畢");
                        // if (this.completeNodesCount !== this.testNodesCount) {
                        //   this.completeNodesCount = this.testNodesCount;
                        // }
                        break;
                    case "TaskErr":
                        // 測試失敗 補上資訊
                        this.testResult = this.testResult.map(e => {
                            e.speed = null ? -1 : e.speed;
                            e.latency = null ? -1 : e.latency;
                            return e;
                        });
                        this.$Message.error("稍後再試");
                        // if (this.completeNodesCount !== this.testNodesCount) {
                        //   this.completeNodesCount = this.testNodesCount;
                        // }
                        break;
                }
                // this.viewSlotInfo.slbclients = clients;
                // alert(clients);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SlbSetting/LineOptimize.vue